export default __webpack_public_path__ + "static/media/truck.0493061b.svg";